import {axiosInstance, getAuthToken} from '../utils/Client';
import moment from "moment/moment";

export default class AgencyRevenueService {
    static plList = async (locationId) => {
        return await axiosInstance.get(`/pl/list/${locationId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static piChart = async(plId) => {
        return await axiosInstance.get(`/revenue/pi_chart/${plId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static lineGraph = async(plId) => {
        return await axiosInstance.get(`revenue/line_chart/${plId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getRevenuePlProfile = (plId) => {
        return axiosInstance.get(`/revenue/pl_profile/${plId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static addNewRevenuePlProfile = (plId) => {
        return axiosInstance.post(`/revenue/pl_profile/${plId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static saveRevenuePlProfile = async (plId, data) => {
        let newData = Object.assign({}, data);
        data['start_date'] = moment(newData.start_date).format('YYYY-MM-DD');
        data['end_date'] = moment(newData.end_date).format('YYYY-MM-DD');
        if(plId) {
            return await axiosInstance.put(`/revenue/pl_profile/${plId}/`,
                data,
                {
                    headers: {
                        Authorization: getAuthToken()
                    }
                }
            );
        } else {
            return await axiosInstance.post(`/revenue/pl_profile/`,
                data,
                {
                    headers: {
                        Authorization: getAuthToken()
                    }
                }
            );
        }
    };

    static getRevenue = (plId) => {
        return axiosInstance.get(`/revenue/actual/${plId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static saveRevenue = (revenue, plId) => {
        return axiosInstance.put(`/revenue/actual/${plId}/`,
            revenue,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getRevenueGoal = (plId) => {
        return axiosInstance.get(`/revenue/goal/${plId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static saveRevenueGoal = (revenueGoal, plId) => {
        return axiosInstance.put(`/revenue/goal/${plId}/`,
            revenueGoal,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getOverrideRevenueGoal = (plId) => {
        return axiosInstance.get(`/revenue/goal/override/${plId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static saveOverrideRevenueGoal = (overrideRevenueGoal, plId) => {
        return axiosInstance.put(`/revenue/goal/override/${plId}/`,
            overrideRevenueGoal,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getCompensationPaid = (plId) => {
        return axiosInstance.get(`/revenue/compensation_paid/${plId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static savecompensationPaid = (compensationPaid, plId) => {
        return axiosInstance.put(`/revenue/compensation_paid/${plId}/`,
            compensationPaid,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static saveCombined = (combineFlag, plId) => {
        return axiosInstance.put(`/revenue/combine/${plId}/`,
            combineFlag,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static saveOverride = (overrideFlag, plId) => {
        return axiosInstance.put(`/revenue/override/${plId}/`,
            overrideFlag,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static saveEnable = (enable, plId) => {
        return axiosInstance.put(`/revenue/enable/${plId}/`,
            enable,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/services/AgencyRevenueService.js